import { useEffect, useState } from 'react';

// Types
import { BootStep } from '../types/boot';

const initialState = {
  isBooting: true,
};

export function useBoot(bootSteps: BootStep[]) {
  const [status, setStatus] = useState(initialState);

  useEffect(() => {
    Promise
      .all(bootSteps.map(step => step.installer()))
      .then(() => {
        setStatus({ isBooting: false });
      });
  }, [bootSteps]);

  return status;
}
